export function getIchimokuStyles() {
	return {
		chikou: {
			color: '#F34949',
			width: 1.25,
			lineDash: null
		},
		kijun: {
			color: '#2E8AAC',
			width: 1.25,
			lineDash: null
		},
		senkou: {
			a: {
				color: 'green',
				width: 1.25,
				lineDash: null
			},
			b: {
				color: 'red',
				width: 1.25,
				lineDash: null
			},
			negative: {
				color: 'rgba(255, 0, 0, 0.2)'
			},
			positive: {
				color: 'rgba(73, 184, 64, 0.3)'
			}
		},
		tenkan: {
			color: '#9A4AEC',
			width: 1.25,
			lineDash: null
		},
		sessionBreak: {}
	};
}
